module.exports = __webpack_public_path__ + "static/media/login-background.d4eb9887.svg";